<template>
    <div class="help_center">
        <div class="delegate yl-flex">
            <div  class="hand dele" @click="() => {menuName = menu.key}" :class="{'active': menu.key == menuName}" v-for="(menu,index) in menuList" :key="index">
                {{menu.name}}
            </div>
        </div>
        <div style="display: flex;justify-content: center;">
            <div class="main-area" v-if="menuName == 'list'">
                <div style="text-align: right"><Button @click="addNew" class='assign' type="primary">+ 添加信息查询</Button></div>
                <div class="multiple">
                    <Table :columns="columns" :data="data" size="small" ref="table">
                        <div slot="operation" slot-scope="{ row }">
                            <a @click="editInformation" style="padding-right:10px" :data-id="row.id">查看</a>
                            <a  @click="delInformation" :data-id="row.id">删除</a>
                        </div>
                    </Table>
                </div>
                <div class="pager">
                    <Page :total="count" :page-size="20" :current="page" @on-change="changePage"
                          size="small" show-total show-elevator/>
                </div>
            </div>
            <div class="main-area" v-if="menuName == 'category_list'">
                <div style="text-align: right"><Button @click="addNewCategory" class='assign' type="primary">+ 添加分类</Button></div>
                <div class="multiple">
                    <Table :columns="categoryColumns" :data="categoryList" size="small" ref="table">
                        <div slot="operation" slot-scope="{ row }">
                            <a @click="editCategory" style="padding-right:10px" :data-id="row.id">查看</a>
                            <a @click="delCategory" :data-id="row.id">删除</a>
                        </div>
                    </Table>
                </div>
            </div>

            <Modal v-model="addInformationModal"
                    title="添加信息"
                    @on-cancel="() => {addInformationModal = false}"
                    @on-ok="saveInformation">
                <Form ref="formValidate" :label-width="80">
                    <FormItem label="名称" prop="date">
                        <Input v-model="formData['name']" placeholder="请输入名称"></Input>
                    </FormItem>
                    <FormItem label="预览图" prop="date">
                        <div style="display: flex; justify-content: space-between;align-items: center; width: 90%">
                            <div v-if="formData.ext_info.logo"><img style="width: 80px; height: 80px; border-radius: 50%" :src="formData.ext_info.logo"></div>
                            <Button type="primary" @click="uploadIcon">上传图标</Button>
                        </div>
                        <div>建议100*100</div>
                    </FormItem>
                    <FormItem label="分类" prop="date">
                        <Select v-model="formData.category">
                            <Option v-for="item in categoryList" :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="链接" prop="date">
                        <Input v-model="formData['ext_info']['url']" placeholder="请输入链接"></Input>
                    </FormItem>
                </Form>
            </Modal>
            <Modal v-model="addCategoryModal"
                   title="添加信息分类"
                   @on-cancel="() => {addCategoryModal = false}"
                   @on-ok="saveCategory">
                <Form ref="formValidate" :label-width="80">
                    <FormItem label="名称" prop="date">
                        <Input v-model="formDataCate['name']" placeholder="请输入名称"></Input>
                    </FormItem>
                </Form>
            </Modal>
        </div>

        <Modal
                v-model="uploadModal"
                title="上传图片"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
        </Modal>
    </div>
</template>

<script>
    import addFile from '../tool/addFile.vue';
    import {mapGetters} from 'vuex';
    import {getInformationList, getInformationCategoryList, saveInformation, getInformation, saveInformationCategory, getInformationCategory,delInformationCategory, delInformation} from '@/api/admin'

    export default {
        name: "information",
        components: {
            addFile
        },
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                menuList: [
                    {key: 'list', name: '信息查询列表'},
                    {key: 'category_list', name: '信息查询分类'},
                ],
                menuName: 'list',
                uploadType: '',
                uploadModal: false,
                addInformationModal: false,
                addCategoryModal: false,
                categoryList: [],
                formData: {
                    category: 0,
                    'name': '',
                    ext_info: {url: '', logo: ''},
                },
                formDataCate: {name:''},
                data: [],
                page: 1,
                count: 0,
                columns: [
                    {
                        "title": "id",
                        "key": "id",
                        "width": 80,
                    },
                    {
                        "title": "名称",
                        "key": "name",
                        "width": 150
                    },
                    {
                        "title": "所属分类",
                        "key": "category_name",
                        "width": 230
                    },
                    {
                        "title": "添加时间",
                        "key": "created_at",
                        "width": 250
                    },
                    {
                        "title": "更新时间",
                        "key": "updated_at",
                        "width": 300,
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "width": 300,
                    }
                ],
                categoryColumns: [
                    {
                        "title": "id",
                        "key": "id",
                        "width": 210,
                    },
                    {
                        "title": "名称",
                        "key": "name",
                        "width": 250
                    },
                    {
                        "title": "添加时间",
                        "key": "created_at",
                        "width": 250
                    },
                    {
                        "title": "更新时间",
                        "key": "updated_at",
                        "width": 300,
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "width": 300,
                    }
                ]
            }
        },
        created(){
            this.loadData();
            this.getList();
        },
        methods: {
            changePage(e) {
                this.page = e;
                this.loadData();
                this.getList();
            },
            selectMenu(e) {
                this.menuName = e;
            },
            uploadLogo() {
                this.uploadType = 'logo';
                this.uploadModal = true
            },
            uploadIcon() {
                this.uploadType = 'icon';
                this.uploadModal = true
            },
            fileOk() {
                var that = this;
                that.formData['ext_info']['logo'] = that.$refs['addFile'].fileUrl;
                that.$refs['addFile'].clear();
            },
            async loadData() {
                let that = this;
                let data = {token: that.token}
                let res = await getInformationCategoryList(that, data);
                if (res.code == 1) {
                    that.categoryList = res.data.list;
                }
            },
            async getList() {
                let that = this;
                let data = {token: that.token, page: this.page}
                let res = await getInformationList(that, data);
                if (res.code == 1) {
                    that.data = res.data.list;
                    that.count = res.count;
                }
            },
            addNew() {
                let that = this;
                that.initFormData();
                this.addInformationModal = true;
            },
            editInformation(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                this.throttle(async function () {
                    let data = {token: that.token, id: id}
                    let res = await getInformation(that, data);
                    if (res.code == 1) {
                        that.formData = res.data.item;
                        that.addInformationModal = true;
                    }
                }, 1000);
            },
            delInformation(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认删除吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id: id}
                            let res = await delInformation(that, data);
                            if (res.code == 1) {
                                that.$Message.success('删除成功');
                                that.getList();
                            }
                        }, 1000);
                    }
                })
            },
            saveInformation() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, formData: that.formData}
                    let res = await saveInformation(that, data);
                    if (res.code == 1) {
                        that.$Message.success('保存成功');
                        that.initFormData();
                        that.getList();
                    }
                }, 1000);
            },
            initFormData() {
                this.formData = {
                    category: 0,
                    'name': '',
                    ext_info: {url: '', logo: ''},
                };
            },
            addNewCategory() {
                this.addCategoryModal = true;
            },
            editCategory(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                this.throttle(async function () {
                    let data = {token: that.token, id: id}
                    let res = await getInformationCategory(that, data);
                    if (res.code == 1) {
                        that.formDataCate = res.data.item;
                        that.addCategoryModal = true;
                    }
                }, 1000);
            },
            delCategory(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认删除吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id: id}
                            let res = await delInformationCategory(that, data);
                            if (res.code == 1) {
                                that.$Message.success('删除成功');
                                that.loadData();
                            }
                        }, 1000);
                    }
                })
            },
            saveCategory() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, formData: that.formDataCate}
                    let res = await saveInformationCategory(that, data);
                    if (res.code == 1) {
                        that.$Message.success('保存成功');
                        that.formDataCate = {name:''};
                        that.loadData();
                    }
                }, 1000);
            }
        }
    }
</script>

<style scoped lang="less">
    .help_center {
        height: 100%;
        background: #f5f7f9;
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
    }
    .ivu-form-item{
        display: inline-block;
        width: 300px;
        margin-left: 15px;
    }
    .main-area{
        width: 100%; height: 300px; background-color: #FFFFFF; padding: 20px;
    }

    .multiple {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: 10px;

        .child-div {
            width: 85px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
            font-size: 12px;
        }
        span{
            font-size: 12px;
        }
        label{
            font-size: 12px;
        }
    }

    .delegate {
        justify-content: start;
        align-items: flex-end;
    }
    .dele {
        font-size: 12px;
        padding: 0 25px;
        border: 1px solid #e0e2e6;
        color: #666;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .dele.active {
        padding: 5px 20px;
        background: #0092ff;
        color: #fff;
    }
    /deep/ .ivu-table table {
        width: 100% !important;
    }
</style>
